import { Box, Flex, Text } from '@chakra-ui/react';
import { Select } from '@document/common/Select';
import { memo } from 'react';

interface ContactableSelectProps {
  value: boolean;
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
}

interface Option {
  label: string;
  value: 'yes' | 'no';
}

const options: Option[] = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

const selectStyles = {
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean; isFocused: boolean }
  ) => ({
    ...provided,
    bg: state.isSelected
      ? 'whiteAlpha.200'
      : state.isFocused
        ? 'whiteAlpha.100'
        : 'transparent',
    color: 'white',
    fontSize: 'sm',
    py: 2,
    px: 3,
    cursor: 'pointer',
    _hover: { bg: 'whiteAlpha.100' },
  }),
};

export const ContactableSelect = memo(function ContactableSelect({
  value,
  onChange,
  isDisabled,
}: ContactableSelectProps) {
  const selectedOption = value ? options[0] : options[1];

  return (
    <Box width="80px">
      <Select<Option>
        chakraStyles={selectStyles}
        components={{
          SingleValue: ({ data }) => (
            <Flex alignItems="center" gap={1} gridArea="1/1/2/3">
              <Text
                color={data.value === 'yes' ? 'green.400' : 'whiteAlpha.600'}
                fontSize="sm"
              >
                {data.label}
              </Text>
            </Flex>
          ),
        }}
        getOptionLabel={(opt) => opt.label}
        getOptionValue={(opt) => opt.value}
        isDisabled={isDisabled}
        isSearchable={false}
        menuPlacement="auto"
        menuPortalTarget={document.body}
        options={options}
        value={selectedOption}
        onChange={(newValue) => {
          if (newValue) {
            onChange(newValue.value === 'yes');
          }
        }}
      />
    </Box>
  );
});
